module.exports = __webpack_public_path__ + "static/media/whatsapp.8003b742.svg";